import React from 'react';
export const AnnouncementBanner = () => {
  return <div className="w-full bg-gray-800 py-2 px-4 text-center" data-id="element-346" data-mp="ivxpc5bg1zqr">
      <p className="text-white text-sm md:text-base" data-id="element-347" data-mp="210kasauagts6">
        🎉 Big News: The Networking Salon is now membership-based! Founder's
        Offer: ₦20,000/year (ends Dec 31). Regular price ₦50,000/year from Jan
        1, 2025.
      </p>
    </div>;
};